import React, { useState, useMemo } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import SideMenu from '../navbar/SideMenu';
import SideMenuBuhumuza from '../navbar/SideMenuGitega'; 
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TextField,
  List, 
  ListItem, 
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Stack
} from '@mui/material';

import {
  ExpandLess,
  Search,
  Menu as MenuIcon,
  ExpandMore,
  LocationOn,
  TrendingUp,
  TrendingDown,
  Group
} from '@mui/icons-material';

const drawerWidth = 240;
const rightDrawerWidth = 280; 
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const RightDrawerWrapper = styled('div')(({ theme }) => ({
  width: rightDrawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    right: 0,
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(100%)',
    },
  }
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ZoneRow = styled(TableRow)({
  backgroundColor: '#f8f8f8',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#e8e8e8 !important'
  }
});

const mwaroData = {
  title: "REPARTITION DE LA POPULATION DES MENAGES ORDINAIRES PAR COLLINE, ZONE ET COMMUNE",
  province: {
    id: "1",
    name: "BUHUMUZA",
    commune: {
      id: "106",
      name: "MWARO",
      total: 145590,
      zones: [
        {
          id: "10601",
          name: "BISORO",
          total: 14514,
          collines: [
            { id: "10601101", name: "GITARAMUKA", population: 3986 },
            { id: "10601102", name: "KIGANDA", population: 3685 },
            { id: "10601103", name: "MUSUMBA", population: 2458 },
            { id: "10601104", name: "BUBURU", population: 2982 },
            { id: "10601105", name: "MABAYA", population: 1403 }
          ]
        },
        {
          id: "10602",
          name: "GATWE",
          total: 11441,
          collines: [
            { id: "10602101", name: "RWUYA", population: 2468 },
            { id: "10602102", name: "NYAGITONGATI", population: 2857 },
            { id: "10602103", name: "MAGO", population: 1708 },
            { id: "10602104", name: "NYAMUGARI", population: 1604 },
            { id: "10602105", name: "KANYAMI", population: 1152 },
            { id: "10602106", name: "BWAKIRA", population: 733 },
            { id: "10602107", name: "MARAMVYA", population: 919 }
          ]
        },
        {
          id: "10603",
          name: "GISOZI",
          total: 12291,
          collines: [
            { id: "10603101", name: "RUYANGE", population: 947 },
            { id: "10603102", name: "NYARUKINYA", population: 251 },
            { id: "10603103", name: "KIBIMBA", population: 3036 },
            { id: "10603104", name: "NYAMIYAGA", population: 1463 },
            { id: "10603105", name: "NDAVA", population: 1619 },
            { id: "10603106", name: "RWEZA", population: 1942 },
            { id: "10603107", name: "MUSIVYA", population: 1603 },
            { id: "10603108", name: "BUBURU", population: 1032 },
            { id: "10603109", name: "GISOZI", population: 398 }
          ]
        },
        {
          id: "10604",
          name: "KANKA",
          total: 13776,
          collines: [
            { id: "10604101", name: "RUBAMVYE", population: 2687 },
            { id: "10604102", name: "MASANGO", population: 2772 },
            { id: "10604103", name: "KANKA", population: 2500 },
            { id: "10604104", name: "BUHABWA", population: 2279 },
            { id: "10604105", name: "KARIBA", population: 2117 },
            { id: "10604106", name: "NYABISIGA", population: 1421 }
          ]
        },
        {
          id: "10605",
          name: "KAYOKWE",
          total: 22145,
          collines: [
            { id: "10605101", name: "RURAMBA", population: 3755 },
            { id: "10605102", name: "KIBOGOYE", population: 4560 },
            { id: "10605103", name: "MUSAMA", population: 2300 },
            { id: "10605104", name: "SASWE", population: 4533 },
            { id: "10605105", name: "RUSIVYA", population: 2637 },
            { id: "10605106", name: "RUVUMU", population: 2800 },
            { id: "10605107", name: "BENJA", population: 1560 }
          ]
        },
        {
          id: "10606",
          name: "MAKAMBA",
          total: 8962,
          collines: [
            { id: "10606101", name: "NYAMURENGE", population: 1833 },
            { id: "10606102", name: "KIRAMBI", population: 1522 },
            { id: "10606103", name: "GASENYI", population: 2063 },
            { id: "10606104", name: "RWINTARE", population: 1283 },
            { id: "10606105", name: "MAKAMBA", population: 1326 },
            { id: "10606106", name: "NYAMIYAGA", population: 935 }
          ]
        },
        {
          id: "10607",
          name: "MUYEBE",
          total: 16180,
          collines: [
            { id: "10607101", name: "MIGENDE", population: 1713 },
            { id: "10607102", name: "MUYEBE", population: 2811 },
            { id: "10607103", name: "GITUNGA", population: 2532 },
            { id: "10607104", name: "NYAKIBARI", population: 3363 },
            { id: "10607105", name: "BISORO", population: 1959 },
            { id: "10607106", name: "RWANKANGOMA", population: 2251 },
            { id: "10607107", name: "MUREHE", population: 1551 }
          ]
        },
        {
          id: "10608",
          name: "MWARO",
          total: 17330,
          collines: [
            { id: "10608101", name: "KAGOMA", population: 1942 },
            { id: "10608102", name: "RUVUMERA", population: 1423 },
            { id: "10608103", name: "GASUMO", population: 623 },
            { id: "10608104", name: "GIHINGA", population: 3151 },
            { id: "10608105", name: "KIZI", population: 1963 },
            { id: "10608106", name: "RURTYAZO", population: 1778 },
            { id: "10608107", name: "NGARA", population: 2165 },
            { id: "10608108", name: "BISHA", population: 1895 },
            { id: "10608109", name: "NKUNDUSI", population: 1919 },
            { id: "10608110", name: "GATARE", population: 471 }
          ]
        },
        {
          id: "10609",
          name: "NYAKARARO",
          total: 17045,
          collines: [
            { id: "10609101", name: "KIYANGE", population: 4055 },
            { id: "10609102", name: "BUTEGANA", population: 2643 },
            { id: "10609103", name: "NYAKIRWA", population: 2765 },
            { id: "10609104", name: "NYAGAHWABARE", population: 3067 },
            { id: "10609105", name: "MUSIMBWE", population: 2344 },
            { id: "10609106", name: "MUGERO", population: 2171 }
          ]
        },
        {
          id: "10610",
          name: "RORERO",
          total: 11906,
          collines: [
            { id: "10610101", name: "MUNANIRA", population: 3041 },
            { id: "10610102", name: "MASHUNZI", population: 2380 },
            { id: "10610103", name: "KIRIKA", population: 3482 },
            { id: "10610104", name: "KIVOGA", population: 3003 }
          ]
        }
      ]
    }
  }
};

const PopulationDataPageGitegaMwaro = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileRightOpen, setMobileRightOpen] = useState(false);
  const [expandedZones, setExpandedZones] = useState({});
  const [openKeyStats, setOpenKeyStats] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleRightDrawerToggle = () => {
    setMobileRightOpen(!mobileRightOpen);
  };

  const toggleZone = (zoneId) => {
    setExpandedZones(prev => ({
      ...prev,
      [zoneId]: !prev[zoneId]
    }));
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data;
    
    const filteredZones = data.province.commune.zones.map(zone => {
      const filteredCollines = zone.collines.filter(colline =>
        colline.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
      return {
        ...zone,
        collines: filteredCollines,
        show: filteredCollines.length > 0 || 
              zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      };
    }).filter(zone => zone.show || !searchTerm);
    
    return {
      ...data,
      province: {
        ...data.province,
        commune: {
          ...data.province.commune,
          zones: filteredZones
        }
      }
    };
  };

  const filteredData = filterData(mwaroData, searchTerm);

  const keyStats = useMemo(() => {
    const commune = mwaroData.province.commune;
    
    const mostPopulatedZone = commune.zones.reduce((max, zone) => 
      zone.total > max.total ? zone : max, commune.zones[0]);
    
    const leastPopulatedZone = commune.zones.reduce((min, zone) => 
      zone.total < min.total ? zone : min, commune.zones[0]);
    
    const mostPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((max, colline) => colline.population > max.population ? colline : max, commune.zones[0].collines[0]);
    
    const leastPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((min, colline) => colline.population < min.population ? colline : min, commune.zones[0].collines[0]);

    const zonePercentages = commune.zones.map(zone => ({
      ...zone,
      percentage: ((zone.total / commune.total) * 100).toFixed(1)
    }));
    
    return {
      totalPopulation: commune.total.toLocaleString(),
      totalZones: commune.zones.length,
      totalCollines: commune.zones.reduce((sum, zone) => sum + zone.collines.length, 0),
      mostPopulatedZone,
      leastPopulatedZone,
      mostPopulatedColline,
      leastPopulatedColline,
      zonePercentages,
      communeTotal: commune.total
    };
  }, []);

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            <SideMenu /> 
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            <SideMenu />
          </Drawer>
        )}

       
        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
                <Button 
                  variant="outlined" 
                  endIcon={<MenuIcon />} 
                  onClick={handleRightDrawerToggle}
                  sx={{ color: secondaryColor, borderColor: secondaryColor }}
                >
                  Info MWARO
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="body1" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {mwaroData.title}
                    </Typography>
                    <Chip 
                      icon={<Group />} 
                      label={`Commune de MWARO`} 
                      color="primary" 
                      variant="outlined" 
                    />
                  </Box>
                  
                  <Grid container spacing={1} style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6}></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher zone/colline..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '400px' } }}
                      />
                    </Grid>
                  </Grid>
                
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                         Commune de MWARO
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Totale
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="primary">
                                {keyStats.totalPopulation}
                              </Typography>
                              <Typography variant="caption">
                                Habitants
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Zones
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="secondary">
                                {keyStats.totalZones}
                              </Typography>
                              <Typography variant="caption">
                                Zones répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Collines
                              </Typography>
                              <Typography variant="h4" fontWeight="bold">
                                {keyStats.totalCollines}
                              </Typography>
                              <Typography variant="caption">
                                Collines répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.mostPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.leastPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.leastPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.mostPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.leastPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>

                     
                      <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                          Répartition de la population par zone
                        </Typography>
                        {keyStats.zonePercentages.map((zone) => (
                          <Box key={zone.id} sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                              <Typography variant="body2">
                                {zone.name}
                              </Typography>
                              <Typography variant="body2" fontWeight="bold">
                                {zone.percentage}% ({zone.total.toLocaleString()})
                              </Typography>
                            </Box>
                            <LinearProgress 
                              variant="determinate" 
                              value={zone.percentage} 
                              sx={{ 
                                height: 8, 
                                borderRadius: 4,
                                backgroundColor: '#e0e0e0',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: zone.id === keyStats.mostPopulatedZone.id ? primaryColor : 
                                                zone.id === keyStats.leastPopulatedZone.id ? secondaryColor : '#888',
                                }
                              }} 
                            />
                          </Box>
                        ))}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Zone/Colline</TableCell>
                          <TableCell align="right">Population</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {filteredData.province.commune.zones.map((zone) => (
                          <React.Fragment key={zone.id}>
                            <ZoneRow 
                              hover 
                              onClick={() => toggleZone(zone.id)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row" colSpan={2}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedZones[zone.id] ? <ExpandLess /> : <ExpandMore />}
                                  <LocationOn sx={{ mr: 1, color: primaryColor }} />
                                  {zone.name}
                                </Box>
                              </TableCell>
                            </ZoneRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={2}>
                                <Collapse in={expandedZones[zone.id] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {zone.collines.map((colline) => (
                                        <TableRow key={colline.id} hover>
                                          <TableCell sx={{ pl: 4 }}>{colline.name}</TableCell>
                                          <TableCell align="right">{colline.population.toLocaleString()}</TableCell>
                                        </TableRow>
                                      ))}
                                      <TableRow>
                                        <TableCell sx={{ pl: 4, fontWeight: 'bold' }}>Total {zone.name}</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>{zone.total.toLocaleString()}</TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                        <TableRow sx={{ backgroundColor: '#e0e0e0', fontWeight: 'bold' }}>
                          <TableCell>TOTAL COMMUNE DE MWARO</TableCell>
                          <TableCell align="right">{mwaroData.province.commune.total.toLocaleString()}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                </Paper>
                
               
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Structure administrative - Commune de MWARO
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      La commune de MWARO est divisée en {keyStats.totalZones} zones administratives:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      {keyStats.zonePercentages.map((zone, index) => (
                        <ListItem key={zone.id}>
                          <ListItemText 
                            primary={`${index + 1}. ${zone.name}`} 
                            secondary={`Population: ${zone.total.toLocaleString()} habitants (${zone.percentage}%) - ${zone.collines.length} collines`} 
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
                
              
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population. 
                    Les chiffres incluent uniquement la population des ménages ordinaires.
                    Les pourcentages sont calculés par rapport à la population totale de la commune de MWARO ({keyStats.totalPopulation} habitants).
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>

        
        {!isMobile ? (
          <RightDrawerWrapper>
            <SideMenuBuhumuza />
          </RightDrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            anchor="right"
            open={mobileRightOpen}
            onClose={handleRightDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: rightDrawerWidth },
            }}
          >
            <SideMenuBuhumuza /> 
          </Drawer>
        )}
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default PopulationDataPageGitegaMwaro;